<mat-card class="mat-elevation-z8">
    <form [formGroup]="district_register_form">
        <!-- user details -->
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label>District Name <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
                    <input type="text" class="form-control code_box" formControlName='name'>
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label for="exampleFormControlSelect1">State</label>
                    <select class="form-control dropdown_box" formControlName='state_id'>
                        <option *ngFor="let state of states" [value]="state['id']">{{state['name']}}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label>District Code <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
                    <input type="text" class="form-control code_box" formControlName='code'>
                </div>
            </div>
            <div class="col">
                    <div class="form-group">
                        <label>District Capital <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
                        <input type="text" class="form-control code_box" formControlName='capital'>
                    </div>
                </div>
        </div>

        <button style="margin-left: 40%;" mat-raised-button color="primary" (click)="registerDistrict()"
            [disabled]="!district_register_form.valid">{{action}}</button>
    </form>
</mat-card>
